<!-- 搜索页面，对应正式环境数据 -->
<template>
  <div class="main">
    <div class="main_bg">
      <div class="main2-content">
        <div style="height: 50px"></div>
        <div class="layout-flex">
          <div class="search_tit">
            找到与您的搜索词“<span>{{ search }}</span
            >”匹配的 <span>{{ count }}</span> 个结果
          </div>
          <div class="search_result_title">搜索结果</div>
          <div
            class="layout-flex-item"
            v-for="(item, index) in selectList"
            :key="index"
            @click="handleDetail(item)"
          >
            <div class="item-title">
              <span>{{ item.title }}</span>
              <span style="float: right; color: #999">{{
                item.onlinestart
              }}</span>
            </div>
            <div class="item-intro" v-html="item.description"></div>
          </div>
          <div style="text-align: right">
            <el-pagination
              layout="prev, pager, next, jumper"
              :total="count"
              :current-page="page"
              @current-change="currentPage"
            >
            </el-pagination>
          </div>
        </div>
        <div style="height: 120px"></div>
      </div>
    </div>
  </div>
</template>

<script>
import config from "./config";
import { csvw_url } from "../../components/config";
export default {
  components: {},
  data() {
    return {
      search: "",
      page: 1,
      count: 0,
      selectList: [],
    };
  },

  mounted() {
    this.search = this.$route.query.search || "";
    this.page = 1;
    this.count = 0;
    this.selectList = [];
    this.getList();
  },
  methods: {
    // 列表
    getList() {
      this.selectList = [];
      this.axios
        .get(
          `https://www.csvw.com/front/news/search?keyword=${this.search}&page=${this.page}&limit=10`
        )
        .then((res) => {
          let count = res.data.count;
          let list = res.data.data;
          this.count = count;
          this.selectList = list;
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(() => {});
    },
    currentPage(page) {
      this.page = page;
      this.getList();
    },
    handleDetail(item) {
      if (item.id) {
        window.open(
          `https://www.csvw.com/csvw-website/news/company-news.html?newsid=${item.id}`,
          "_self"
        );
      }
    },
  },
};
</script>

<style lang="less" scoped>
.main {
  width: 100%;
  min-width: 1200px;
  margin: 0px auto;
  font-size: 14px;
  font-family: "Microsoft Yahei", "微软雅黑";
}

.main_bg {
  width: 100%;
  min-width: 1200px;
  background: #ffffff;
}

.main2-content {
  width: calc(100% - 60px);
  margin: 0px 30px;
}

.search_tit {
  width: 100%;
  border-bottom: 1px solid #999;
  padding: 10px 0;
  font-size: 16px;
}

.search_tit span {
  color: red;
}

.search_result_title {
  font-size: 16px;
  padding: 10px 0;
}

.layout-flex {
  width: 1200px;
  margin-left: auto;
  margin-right: auto;
  .layout-flex-item {
    margin-bottom: 20px;
    padding: 0px 5px 15px 5px;
    border-bottom: 1px solid #efefef;
    cursor: pointer;
  }
  .item-title {
    color: #666;
    font-size: 14px;
    margin-bottom: 10px;
  }
  .item-intro {
    font-size: 14px;
    color: #999;
    line-height: 21px;
    /deep/p {
      margin: 0px;
    }
  }
}

@media screen and (min-width: 1600px) {
  .main2-content {
    .layout-flex {
      width: 1600px;
    }
  }
}
</style>
